// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Ach } from './ach';
import { EmailAttachment } from './email-attachment';
import { Invoice } from './invoice';
import { Order } from './order';
import { PackingSlip } from './packing-slip';
import { PurchaseOrder } from './purchase-order';
import { User } from './user';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class EmailMessage extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get type() {
        return this.invoiceId ? 'Invoice'
            : this.salesOrderId && this.mode === 'MSRP' ? 'SalesOrderMsrps'
            : this.salesOrderId && this.salesOrder.typeId !== Order.Types.Warranty ? 'SalesOrder'
            : this.salesOrderId && this.salesOrder.typeId === Order.Types.Warranty ? 'Warranty'
            : this.achId ? 'ACH'
            : 'PurchaseOrder';
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  achId?: number;
  bcc?: string;
  body?: string;
  cc?: string;
  created!: Date;
  createdById?: number;
  invoiceId?: number;
  mode?: string;
  packingSlipId?: number;
  purchaseOrderId?: number;
  salesOrderId?: number;
  sent?: Date;
  subject?: string;
  to?: string;
  ach!: Ach;
  createdBy!: User;
  emailAttachments!: EmailAttachment[];
  invoice!: Invoice;
  packingSlip!: PackingSlip;
  purchaseOrder!: PurchaseOrder;
  salesOrder!: Order;
}

